"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.RowContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _ThemeProvider = _interopRequireWildcard(require("../ThemeProvider"));

var _screenSize = _interopRequireDefault(require("../../screenSize"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: ", ";\n  justify-content: flex-start;\n  margin: ", "px -", "px;\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var RowContext = (0, _react.createContext)({
  theme: _ThemeProvider.DEFAULT_THEME,
  rowSize: 12
});
exports.RowContext = RowContext;

var RowView = _native.default.View(_templateObject(), function (props) {
  return props.nowrap ? 'nowrap' : 'wrap';
}, function (props) {
  return props.muiTheme.spacing / 2;
}, function (props) {
  return props.muiTheme.spacing / 2;
}, function (props) {
  return props.inner ? "margin: " + props.muiTheme.spacing / 2 + "px 0;" : '';
}, function (props) {
  return props.top ? 'margin-top: 0' : '';
}, function (props) {
  return props.bottom ? 'margin-bottom: 0' : '';
});

var Row =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Row, _Component);

  function Row() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var theme = (0, _ThemeProvider.getTheme)('Grid', this.props, this.context);
    return _react.default.createElement(RowView, (0, _extends2.default)({}, this.props, {
      muiTheme: theme
    }), _react.default.createElement(RowContext.Provider, {
      value: {
        rowSize: this.props.size,
        theme: theme
      }
    }, this.props.children));
  };

  return Row;
}(_react.Component);

(0, _defineProperty2.default)(Row, "contextType", _ThemeProvider.default);
(0, _defineProperty2.default)(Row, "defaultProps", {
  size: 12,
  nowrap: false
});

var _default = (0, _screenSize.default)(Row);

exports.default = _default;